import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';

interface EditTextDialogProps {
  id: number | undefined;
  value: string | undefined;
  title: string;
  label: string;
  loading: boolean;
  onSave: (id: number, newValue: string) => void;
  onHide: () => void;
}

export const EditTextDialog: React.FC<EditTextDialogProps> = ({
  id,
  value,
  title,
  label,
  loading,
  onSave,
  onHide,
}) => {
  console.log(` EditTextDialog XXXXXXXXXXXX data res: ${value}`);
  const [editValue, setEditValue] = useState<string>(value || '');

  useEffect(() => {
    setEditValue(value || '');
  }, [value]);

  const handleSaveEdit = () => {
    if (id && editValue.trim()) {
      onSave(id, editValue.trim());
      onHide();
    }
  };

  const isVisible = Boolean(id && value);

  return (
    <Dialog
      header={title}
      visible={isVisible}
      style={{
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      onHide={onHide}
    >
      <div className="p-field" style={{ marginBottom: '1rem' }}>
        <label
          htmlFor="entityName"
          style={{ display: 'block', marginBottom: '0.5rem' }}
        >
          {label}
        </label>
        <InputText
          id="entityName"
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          style={{ width: '100%' }}
        />
      </div>
      <div
        style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}
      >
        <Button label="ביטול" severity="secondary" onClick={onHide} />
        <Button
          label="שמירה"
          onClick={handleSaveEdit}
          loading={loading}
          disabled={!editValue.trim()}
        />
      </div>
    </Dialog>
  );
};
